import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases condicionales (clsx) y resuelve conflictos de utilidades de
 * Tailwind (tailwind-merge), de modo que la última clase en conflicto gana.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
